// Factories
import { BaseServiceFactory } from "../../base/factories/BaseServiceFactory";
/** Implementation of the service provider factory for the Uno Teams app */
export class TeamsServiceFactory extends BaseServiceFactory {
}
